import { useEffect, useState } from "react"
import { Route, Routes } from "react-router"
import { WINDOW_WIDTH } from "src/libs/interfaces/layouts"
import useScreenSize from "src/modules/pe-basic-module/hooks/useScreenSize"
import Feed from "src/modules/pe-basic-module/views/core/Feed"
import DiaryCard from "src/modules/pe-basic-module/views/diary/DiaryCard"
import DiarySingleModal from "src/modules/pe-basic-module/views/diary/DiarySingleModal"
import Loading from "src/stories/Loading"
import { ILandFilter } from "../../data/interfaces"
import { IToposStore, useToposStore } from "../../data/store"
import LandsRightPanel from "./LandsRightPanel"

/* Protopia Ecosystem component */
export interface IDiaryFeedProps {
   paging:string
   title: string
}
const DiaryFeed = (props: IDiaryFeedProps): JSX.Element => {
    const {width} = useScreenSize()
    const landFilter: ILandFilter = useToposStore((state:IToposStore) => state.landFilter) 
    const [paging, setPaging] = useState<string>( props.paging || "" )
    const [isPagingLoad, setPagingLoad] = useState<boolean>( false )

    useEffect(()=> {
        setPagingLoad(true)
    }, []) 


    return <div className="w-100 h-100"> 
        <div className="topos-landscape-container h-100">
        {
            !isPagingLoad
                ?
                <div className="w-100 py-5">
                    <Loading /> 
                </div>
                :
                <>
                    <LandsRightPanel />
                    <div className={`topos-landscape-feed overflow-y-auto open pr-4`}>
                        <div className="small-container">
                            {/* <div className="lead-md mb-3 text-center mt-3">{__(props.title)}</div> */}
                            <Feed 
                                offset={0}
                                data_type={"PEDiary"} 
                                land_id={ landFilter.id || "all" }
                                feedBefore={[]}
                                paging={ paging } 
                                class_name=' '
                                containerClassName="w-100" 
                                component={ DiaryCard }
                                // isDateRaze
                                dateRazeClassName="ml-5 my-3 lead-md title"
                                topPagiHide 
                                // bottomPagiHide
                                params={{
                                    //tick: tick,
                                    isLand: true,
                                    minimal: width < WINDOW_WIDTH.TABLET
                                }}
                            />
                        </div>
                    </div>  
                </>
        }
        </div>
        <Routes>
            <Route
                path="/modal/:dairyId"
                element={ <DiarySingleModal />}
            />
        </Routes>
    </div>
}
export default DiaryFeed